export function EmptyStateCard({ text }: { text: string }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed p-8 text-center animate-in fade-in-50">
      <div className="mx-auto flex max-w-[420px] flex-col items-center justify-center text-center">
        <p className="text-sm text-muted-foreground">{text}</p>
      </div>
    </div>
  );
}
